import { logException } from "@punchup/sentry";

const storageKey = (slug: string) => `dashboardSettingsReturnPath:${slug}`;

/**
 * Keeps the dashboard page a user leaves when they open Settings, so the settings
 * variant's Back button can return to it. One page per comedian, for this tab.
 *
 * Call it from a click handler only. The server cannot read `sessionStorage`.
 */
export function rememberSettingsReturnPath(slug: string, path: string): void {
  try {
    sessionStorage.setItem(storageKey(slug), path);
  } catch (error) {
    logException(error);
  }
}

/**
 * Where Back goes out of Settings: the page kept by `rememberSettingsReturnPath`,
 * or the dashboard root when there is none (a deep link into Settings, or a page
 * already used). The kept page is used once, then cleared. A stored path outside this
 * comedian's dashboard falls back to the root.
 *
 * Call it from a click handler only. The server cannot read `sessionStorage`.
 */
export function takeSettingsReturnPath(slug: string): string {
  const root = `/${slug}/dashboard`;
  try {
    const stored = sessionStorage.getItem(storageKey(slug));
    sessionStorage.removeItem(storageKey(slug));
    if (stored?.startsWith(root)) return stored;
  } catch (error) {
    logException(error);
  }
  return root;
}
